import { render } from "./MfittIndex.vue?vue&type=template&id=6f85062e"
import script from "./MfittIndex.vue?vue&type=script&lang=js"
export * from "./MfittIndex.vue?vue&type=script&lang=js"
script.render = render

export default script